import React from 'react'
import PropTypes, { InferProps } from 'prop-types'
import styled from 'styled-components'
import { always, cond, equals, T } from 'ramda'
import * as PCLNAnalytics from '../../../utils/PCLN-Analytics'
import { ANALYTICS_CATEGORY}  from '../../../constants/Constants'
import { Box, Flex, Link, Text } from 'pcln-design-system'
import { Cars, Flights, Hotels} from 'pcln-icons'

const ViewTripLink = styled(Link)`
  padding-left: 16px;
  font-size: 14px;
  font-weight: normal;
`
const trackViewTripClick = () => {
  PCLNAnalytics.send({
    action: 'Feature Box Link',
    category: ANALYTICS_CATEGORY,
    data: 'Cross Sell View Trip'
  })
  return false
}

type ProductIcon = typeof Flights | typeof Cars | typeof Hotels

const getProductIcon = cond<string, ProductIcon>([
  [equals('flight'), always(Flights)],
  [equals('car'), always(Cars)],
  [T, always(Hotels)]
])

function TripDetailsBox ({ product, headline, subHeadline }: InferProps<typeof TripDetailsBox.propTypes>) {
  const ProductIcon = getProductIcon(product || 'hotel')
  return (
    <Flex ml={-2} alignItems='center'>
      <ProductIcon color='primary.dark' size='56' mr={2} />
      <Box ml={1}>
        <Text color='text' fontSize={[2, null, null, 3]} mb={1} fontWeight='bold'>{headline} <ViewTripLink href='/profile/#/mytrips' onClick={trackViewTripClick}>View Trip</ViewTripLink></Text>
        <Text color='text' fontSize={[1, null, null, 2]} mt={1}>{subHeadline}</Text>
      </Box>
    </Flex>
  )
}

TripDetailsBox.propTypes = {
  product: PropTypes.string,
  headline: PropTypes.string,
  subHeadline: PropTypes.string
}

export default TripDetailsBox